module.exports = __webpack_public_path__ + "assets/img/ico-4.cbc7a3f0.webp";